import { createAuthSessionStore } from "@react/foundation/auth";

import { logger } from "../../../bootstrap/logger.ts";
import { STORE_KEY, STORE_VERSION } from "../../../bootstrap/store.ts";

export const { authSessionStore } = createAuthSessionStore({
  logger,
  storeKey: STORE_KEY.authSession,
  storeVersion: STORE_VERSION,
});
